import { jsx as o, Fragment as a, jsxs as m } from "react/jsx-runtime";
import { memo as u, useMemo as d, useCallback as f } from "react";
import { Checkbox as h, Col as p, Row as x } from "antd";
import { u as l } from "../styled-components.browser.esm-3eb04950.js";
import { AdditionalDetailsType as i } from "../typings/additionalDetails.js";
import { useLanguageResolver as g } from "@biron-data/react-contexts";
import y from "../valueDescription/ValueDescription.js";
import b from "../mdView/MdView.js";
const V = u(function({ additionalDetail: t, ...e }) {
  const r = g(), c = r.get(`configuration-chart-additional-detail.${t.textKey}.label`), s = d(() => {
    switch (t.type) {
      case i.checkbox:
        return /* @__PURE__ */ o(v, { label: c, ...e });
      case i.custom:
        return e.onChange ? t.renderComponent({
          value: e.value,
          onChange: e.onChange
        }) : /* @__PURE__ */ o(a, {});
    }
  }, [t, c, e]);
  return /* @__PURE__ */ m(C, { children: [
    s,
    /* @__PURE__ */ o(k, { span: 1, children: !t.hideDescription && /* @__PURE__ */ o(y, { children: /* @__PURE__ */ o(b, { description: r.get(`configuration-chart-additional-detail.${t.textKey}.description`) }) }) })
  ] });
}), k = l(p)`
  display: flex;
  margin-left: 5px;
  justify-content: center;
`, C = l(x)`
  display: flex;
  flex-direction: row;
`, v = ({ label: n, value: t, onChange: e }) => {
  const r = f(
    (c) => {
      e == null || e(c.target.checked);
    },
    [e]
  );
  return /* @__PURE__ */ o(
    h,
    {
      checked: t,
      onChange: r,
      children: n
    }
  );
};
export {
  V as default
};
//# sourceMappingURL=AdditionalDetailSelector.js.map
